import React, { useState, useEffect } from 'react';
import { Field, Form, getFormValues, reduxForm } from 'redux-form';
import styles from '../../styles/forms/add_substage_wizard/AddSubstageForm.scss';
import Button from '../../components/Button';
import Select from '../../components/Select';
import Input from '../../components/Input';
import { __, mapStateToProps, setTableParams } from '../../core/utils';
import { withRouter } from 'react-router';
import ButtonGroup from '../../components/ButtonGroup';
import { subscribe } from 'react-contextual';
import Localization from '../../helpers/Localization';
import * as _ from 'lodash';
import { useCallback } from 'react';
import { listPossibleStages } from '../../redux/actions/table/substages';
import DateTimePicker from '../../components/DateTimePicker';
import Tooltip from '../../components/Tooltip';
import ArrowDownSmallIcon from '../../assets/images/arrow-down-small-15x15.svg';
import classNames from 'classnames';
import Checkbox from '../../components/Checkbox';

const AddSubstageForm = ({
  localization,
  handleSubmit,
  onSubmit,
  submitting,
  application_language_id,
  match,
  projectLanguages,
  initialStageId,
  values,
  change,
}) => {
  const [possibleStages, setPossibleStages] = useState([]);

  const _handleSubmit = (create_and_edit) => {
    return handleSubmit((formData) => {
      return onSubmit({
        ...formData,
        edit: create_and_edit,
      });
    })();
  };

  const application_languages = _.transform(
    _.filter(
      localization.languages,
      (language) => language.application_language == true
    ),
    (languages, language) => {
      languages[language.id] = language.id == application_language_id;
      return languages;
    },
    {}
  );

  useEffect(() => {
    const project_id = match.params.project;

    listPossibleStages(project_id).then(({ response }) => {
      setPossibleStages(response.data);
    });
  }, []);

  useEffect(() => {
    if (initialStageId && !values?.stage_id) {
      change('stage_id', initialStageId);
    }
  }, [change, initialStageId, values?.stage_id]);

  // const statuses = [
  //   { label: __('substage.status.started'), value: '0', color: '#5777FC' },
  //   { label: __('substage.status.finished'), value: '1', color: '#ADD42B' },
  // ];

  const statuses = [
    {
      value: 'not-started',
      label: __('stages.status.not-started'),
      color: '#9C27B0',
    },
    {
      value: 'started',
      label: __('stages.status.started'),
      color: '#5777FC',
    },
    {
      value: 'finished',
      label: __('stages.status.finished'),
      color: '#ADD42B',
    },
    {
      value: 'closed',
      label: __('stages.status.closed'),
      color: '#009688',
    },
    {
      value: 'reopened',
      label: __('stages.status.reopened'),
      color: '#303F9F',
    },
    {
      value: 'canceled',
      label: __('stages.status.canceled'),
      color: '#CCCDD1',
    },
  ];

  return (
    <Form onSubmit={handleSubmit} className={styles.wrapper}>
      <div className={styles.form}>
        <div className={styles.flex}>
          <div className={styles.f1}>
            <Field
              name='status'
              component={Select}
              label={__('substage.status')}
              options={statuses}
              noSort
              dropdown
              wrapper={(handleOpen, activeItem, elementRef) => (
                <Tooltip text={__('substage.status')}>
                  <div
                    className={styles.dropdown}
                    ref={elementRef}
                    style={{ background: activeItem.color }}
                    onClick={handleOpen}
                  >
                    <div className={styles.button}>
                      {activeItem.label}
                      <ArrowDownSmallIcon />
                    </div>
                  </div>
                </Tooltip>
              )}
            />
          </div>
          <div className={styles.f1} />
        </div>
        <Field
          name='name'
          localized={projectLanguages}
          component={Input}
          label={__('substage.name')}
        />

        <Field
          name='stage_id'
          component={Select}
          label={__('substage.stage')}
          options={possibleStages}
        />
        <Field
          name='description'
          component={Input}
          localized={projectLanguages}
          label={__('substage.description')}
        />
        <div className={styles.flex}>
          <div className={styles.f2}>
            <Field
              name='date'
              component={DateTimePicker}
              label={__('project.substages.date')}
              footer
              range
            />
          </div>
          <div className={classNames(styles.f1, styles.deadline)}>
            <div className={styles.deadlineLabel}>
              {__('project.substages.column.deadline')}
            </div>
            <Field
              name='date.deadline'
              component={Checkbox}
              className={styles.checkbox}
              onChange={(event) => {}}
              // disabled={disabled}
            />{' '}
          </div>
          <div className={classNames(styles.f1, styles.estimate)}>
            <Field
              name='time_log.planned_time'
              component={Input}
              label={__('project.substages.planned-time')}
              placeholder={__('project.substages.enter-planned-time')}
              // disabled={disabled}
            />
          </div>
          {/* <div className={styles.f1}>
            <Field
              name='duration'
              component={Input}
              label={__('substage.duration')}
            />
          </div> */}
        </div>
      </div>
      <div className={styles.footer}>
        <Button
          lightGray
          medium
          left
          middleText={__('button.cancel')}
          onClick={() =>
            setTableParams('substages', {
              wizard_active: undefined,
            })
          }
        />
        <ButtonGroup>
          <Button
            lightBlue
            medium
            middleText={__('button.create')}
            spinning={submitting}
            onClick={() => _handleSubmit(false)}
          />
        </ButtonGroup>
      </div>
    </Form>
  );
};

export default withRouter(
  reduxForm({ form: 'add_substage_wizard.add_substage' })(
    subscribe(
      Localization,
      'localization'
    )(
      mapStateToProps((state) => ({
        values: getFormValues('add_substage_wizard.add_substage')(state),
        auth: state.auth,
        application_language_id: state.auth.language_id,
      }))(AddSubstageForm)
    )
  )
);
